import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/chongshan.scss' 
import screenAdapter from 'screen-adapter-plugin'
import './utils/rem.js';
import 'animate.css';
Vue.use(screenAdapter, {rootValue: 192}) 
import router from './router'
Vue.config.productionTip = false
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css';

import MyTitle from './components/myTitle/index.vue';
Vue.component('myTitle', MyTitle);

Vue.use(VueAwesomeSwiper)

import 'element-ui/lib/theme-chalk/base.css';

import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
console.log('CollapseTransition.name',CollapseTransition.name)
Vue.component(CollapseTransition.name, CollapseTransition)
document.documentElement.style.setProperty('--scrollbar-width', '0px');
document.documentElement.style.setProperty('--scrollbar-height', '0px');

document.body.style.setProperty('--scrollbar-width', '0px');
document.body.style.setProperty('--scrollbar-height', '0px');

document.documentElement.style.setProperty('scrollbar-width', 'none');
document.documentElement.style.setProperty('scrollbar-height', 'none');

document.body.style.setProperty('scrollbar-width', 'none');
document.body.style.setProperty('scrollbar-height', 'none');
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
